module.exports = __webpack_public_path__ + "assets/img/4_121.9aedad19.jpg";